import { useGLTF } from "@react-three/drei";
import { isMobile } from "react-device-detect";
import React, { useRef, useState } from "react";
import { PointLight } from "three";
import { useFrame, useLoader } from "@react-three/fiber";
import { stageObject } from "../../interface";
import { HoverText } from "../../HoverText";
import * as THREE from "three";

export const Junior = ({
  url,
  scale,
  position,
  getCharacters,
}: stageObject) => {
  const { scene } = useGLTF(url, "/draco/");
  const juniorRef = useRef<any>();
  const textRef = useRef<any>();
  const pointLightRef = useRef<PointLight>(null!);
  const [hovered, setHovered] = useState(false);
  const speed = 0.002; // 初始旋转速度

  // 鼠标移入时显示光源和文本
  const handlePointerOver = () => {
    setHovered(true);
    if (pointLightRef.current) {
      pointLightRef.current.visible = true;
    }
    if (textRef.current) {
      textRef.current.visible = true;
    }
  };

  // 鼠标移出时隐藏光源和文本
  const handlePointerOut = () => {
    setHovered(false);
    if (pointLightRef.current) {
      pointLightRef.current.visible = false;
    }
    if (textRef.current && !isMobile) {
      textRef.current.visible = false;
    }
  };

  let rotationX = true;
  let rotationY = true;
  useFrame(() => {
    if (juniorRef.current) {
      if (
        juniorRef.current.rotation.x < -0.5 ||
        juniorRef.current.rotation.x > 0.5
      ) {
        rotationX = !rotationX;
        rotationY = Math.random() < 0.5;
      }

      if (!hovered) {
        // 缓慢旋转火箭
        if (rotationX) {
          juniorRef.current.rotation.x += speed;
        } else {
          juniorRef.current.rotation.x -= speed;
        }

        if (rotationY) {
          juniorRef.current.rotation.y -= speed;
        } else {
          juniorRef.current.rotation.y += speed;
        }
      }
      const { x, y, z } = juniorRef.current.position;
      if (pointLightRef.current) {
        pointLightRef.current.position.set(x, y - 0.2, z + 0.3);
      }

      if (textRef.current) {
        if (isMobile) {
          textRef.current.visible = true;
          textRef.current.fontSize = "0.2";
          textRef.current.position.set(x, y - 0.3, z - 0.2);
        } else {
          textRef.current.position.set(x + 0.3, y - 0.6, z - 0.2);
        }
      }
    }
  });

  return (
    <>
      <primitive
        ref={juniorRef}
        object={scene}
        position={position}
        scale={scale}
        onClick={() => getCharacters("junior")}
        onPointerOver={handlePointerOver}
        onPointerOut={handlePointerOut}
      />

      <pointLight
        visible={isMobile}
        ref={pointLightRef}
        intensity={2}
        color={"#9c2f31"}
      />
      <HoverText text={"Base"} color={"#9c2f31"} textRef={textRef} />
    </>
  );
};
